export const ACTION_TYPE = 'actionType';
export const FUNCTION_ID = 'functionId';
export const ACTION_TYPE_ID = 'actionTypeId';
export const FUNCTION_SOURCE = 'functionSource';
export const SECRETS = 'secrets';
export const INPUT_FIELDS = 'inputFields';
export const RUNTIME = 'runtime';
export const PACKAGE_ID = 'packageId';
export const DESCRIPTION = 'description';